import { jwtDecode } from 'jwt-decode';

function extractUserFromLocalStorage() {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No token found in localStorage');
    }
    const decoded = jwtDecode(token);  
    const { mobileNumber, userRole, userId } = decoded;

    return {
      mobileNumber,
      userRole,
      userId, 
    };
  } catch (error) {
    return null;
  }
}

export default extractUserFromLocalStorage;
